module.exports = __webpack_public_path__ + "img/link-icon.b4fc913a.svg";